import React, { createContext, useContext, useState } from 'react'
import useIsomorphicLayoutEffect from 'hooks/useIsomorphicLayoutEffect'


export const HasStickyBarProviderContext = createContext([{}, () => {}])

export default function HasStickyBarProviderProvider({
  children,
  initialHasStickyBar = false,
}) {
  const useHasStickyBarProviderState = useState(initialHasStickyBar)
  
return (
  <HasStickyBarProviderContext.Provider value={useHasStickyBarProviderState}>
    {children}
  </HasStickyBarProviderContext.Provider>
  )
}

export function useHasStickyBarProviderContext() {
  return useContext(HasStickyBarProviderContext)
}

export function useRegisterStickyBar() {
  const [, setHasStickybar] = useHasStickyBarProviderContext()

  useIsomorphicLayoutEffect(() => {
    setHasStickybar(true)
    
return () => {
      setHasStickybar(false)
    }
  }, [])
}
